import React, { Component } from 'react'
import { Button, Col, Row, Spinner } from 'reactstrap'
import AddCircleIcon from '@mui/icons-material/AddCircle'
//import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
//import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
//import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  CircularProgress,
} from '@mui/material'
import { activePurchases, orderPurchases, orderTicketCount } from '../../eventtickets'
import { withFirebase } from '../Fb'
import { DataGrid } from '@mui/x-data-grid'
// import PlusMinusButton from '../Buttons/PlusMinusButton'
import moment from 'moment'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import RefreshIcon from '@mui/icons-material/Refresh'
import EventTicketDialog from '../Dialogs/EventTicketsDialog'

// Prices on an event ticket are in euros (purchase.price, variation.price) while
// payment amounts are in cents (payments[].amount, purchase.amount).
function formatEuros(value) {
  return typeof value === 'number' && !isNaN(value) ? value.toFixed(2).replace('.', ',') + ' €' : ''
}

// Both are parsed as UTC clock faces so they can be compared with each other:
// payment timestamps carry no zone, purchase timestamps carry an offset.
function paymentMoment(payment) {
  const m = moment.utc(payment.timestamp, ['YYYY.MM.DD HH:mm', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'])
  return m.isValid() ? m : null
}

function purchaseMoment(purchase) {
  const m = moment.utc(purchase.timestamp, ['YYYY-MM-DD HH:mm:ssZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY.MM.DD HH:mm'])
  return m.isValid() ? m : null
}

// payments[] hangs off the event ticket, not off a single purchase, so a purchase has
// to be matched to its own payment: by paymenttoken when it carries one, otherwise by
// amount and the closest timestamp. `used` stops two equally priced purchases from
// both claiming the same payment.
function matchPayments(purchase, payments, used) {
  if (purchase.paymenttoken) {
    const byToken = payments.filter((p) => p.paymenttoken === purchase.paymenttoken)
    if (byToken.length > 0) {
      byToken.forEach((p) => used.add(p.id))
      return byToken
    }
  }
  const candidates = payments.filter((p) => !used.has(p.id) && p.amount === purchase.amount)
  if (candidates.length === 0) return []
  const purchasedAt = purchaseMoment(purchase)
  let best = candidates[0]
  if (purchasedAt) {
    let bestDiff = Infinity
    candidates.forEach((p) => {
      const paidAt = paymentMoment(p)
      const diff = paidAt ? Math.abs(paidAt.diff(purchasedAt)) : Infinity
      if (diff < bestDiff) {
        bestDiff = diff
        best = p
      }
    })
  }
  used.add(best.id)
  return [best]
}

// 'when how amount', e.g. '05.06.2025 07:58 Online (Paytrail/nordea) 88,00 €'
function paymentsText(payments) {
  return payments
    .map((p) => {
      const paidAt = paymentMoment(p)
      const when = paidAt ? paidAt.format('DD.MM.YYYY HH:mm') : p.timestamp || ''
      const how = p.typelabel || p.type || ''
      const amount = typeof p.amount === 'number' ? formatEuros(p.amount / 100) : ''
      return [when, how, amount].filter(Boolean).join(' ')
    })
    .join(', ')
}


// class AddEventTicketRow extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       selected: '',
//       note: '',
//       saving: this.props.saving,
//       eventtickets: this.props.eventtickets,
//     }
//   }

//   componentDidUpdate(prevProps) {
//     if (this.props.saving !== prevProps.saving) {
//       this.setState({ saving: this.props.saving })
//     }
//     if (this.props.eventtickets !== prevProps.eventtickets) {
//       this.setState({ selected: this.props.eventtickets[0].id })
//     }
//   }

//   onChangeId = (event) => {
//     this.setState({
//       selected: event.target.value,
//     })
//   }

//   onChangeNote = (event) => {
//     this.setState({
//       note: event.target.value,
//     })
//   }

//   handleCancel = () => {
//     this.setState({
//       selected: '',
//       note: '',
//     })
//     this.props.onCancel()
//   }


//   render() {
//     const { onSubmit, onCancel } = this.props
//     // if (!this.state.benefitcards) return <div>Ei sarjakortteja</div>
//     return (
//       <>
//         <Row>
//           <Col xs={12} md={4}>
//             <FormControl style={{ width: '100%' }}>
//               <InputLabel id='benefitcard-label'>Tapahtumalippu</InputLabel>
//               <Select
//                 id='demo-simple-select'
//                 value={this.state.selected}
//                 onChange={this.onChangeId}
//                 required
//                 labelId='benefitcard-label'
//                 fullWidth
//               >
//                 {this.state.eventtickets &&
//                   this.state.eventtickets.map((eventticket) => {
//                     return eventticket.variants.map((variant) => {
//                       return (
//                         <MenuItem key={eventticket.id + '-' + variant.id} value={eventticket.id + '-' + variant.id}>
//                           {eventticket.name} ({variant.name}) - {variant.price / 100} €
//                         </MenuItem>
//                       )
//                     })
//                   })}
//               </Select>
//             </FormControl>
//           </Col>
//           <Col xs={12} md={4}>
//             <Button disable={this.state.saving} outline color='success' size='sm' onClick={() => onSubmit(this.state.selected, this.state.note)}>
//               {this.state.saving ? <Spinner size={'sm'}/> : 'Lisää'}
//             </Button>{' '}
//             <Button disabled={this.state.saving}  outline color='primary' size='sm' onClick={onCancel}>
//               Peruuta
//             </Button>
//           </Col>
//         </Row>
//         <Row>
//           <Col xs={12} md={6}>
//             <TextField
//               fullWidth
//               id='note'
//               label='Muistiinpano'
//               type='text'
//               value={this.state.note || ''}
//               onChange={this.onChangeNote}
//             />
//           </Col>
//         </Row>
//       </>
//     )
//   }
// }


class PersonEventTickets extends Component {
  constructor(props) {
    super(props)
    this.state = {
      eventtickets: this.props.eventtickets || [],
      saving: false,
      loadingPlusMinus: {},
      deleting: false,
      onUpdate: this.props.onUpdate || null,
      showAddCardRow: false,
      confirmRemove: null,
      removeError: null,
    }
  }

  askRemove = (row) => {
    this.setState({ confirmRemove: row, removeError: null })
  }

  closeRemove = () => {
    if (this.state.deleting) return
    this.setState({ confirmRemove: null, removeError: null })
  }

  // Soft cancel of the whole order the row belongs to: those purchases are marked cancelled
  // and drop out of every list, but the payment stays on the event ticket. No money moves.
  removePersonEventTicket = async () => {
    const row = this.state.confirmRemove
    if (!row) return
    const userid = (row.user && row.user.id) || (this.props.person && this.props.person.id)
    this.setState({ deleting: true, removeError: null })
    const response = await this.props.firebase.cancelEventTicketOrder(
      row.eventticketid,
      row.paymenttoken,
      userid
    )
    // cancelEventTicketPurchase resolves with { error } rather than throwing, so a failure
    // never reaches a catch - without this check the dialog would close as if it had worked.
    if (response && response.error) {
      this.setState({ deleting: false, removeError: response.error })
      return
    }
    this.setState({ deleting: false, confirmRemove: null })
    if (this.props.onUpdate) this.props.onUpdate()
  }

  getColumns = () => {
    const columns = [
      { field: 'productCode', headerName: 'Tuotekoodi', width: 130 },
      { field: 'name', headerName: 'Tapahtuma', width: 200 },
      { field: 'variantname', headerName: 'Lippu', width: 200 },
      {
        field: 'start',
        headerName: 'Tapahtuma-aika',
        width: 160,
        // Bound to the raw ISO value so sorting stays chronological. Rendered as the
        // UTC clock face, same as the event ticket list view.
        valueFormatter: (value) => (value ? moment.utc(value).format('DD.MM.YYYY HH:mm') : ''),
      },
      // { field: 'desc', headerName: 'Kuvaus', width: 200 },
      // {
      //   field: 'vat',
      //   headerName: 'Alv',
      //   width: 60,
      //   valueFormatter: (params) => {
      //     return params.value  + '%'
      //   },
      // },
      // {
      //   field: 'remaining', headerName: 'Jäljellä', width: 160, renderCell: (params) => {
      //     if (params.value === 0) return 'Käytetty'
      //     if (params.row.type === 'count') {
      //       return <>{params.value + ' kertaa '} <span style={{ marginLeft: 10 }}><PlusMinusButton onPlus={() => this.handlePlus(params.row.id)} onMinus={() => this.handleMinus(params.row.id)} loading={this.state.loadingPlusMinus[params.row.id]} /></span></>
      //     } else {
      //       return ''
      //     }
      //   }
      // },
      { field: 'quantity', headerName: 'Määrä', width: 60 },
      {
        field: 'price',
        headerName: 'Hinta',
        width: 100,
        valueFormatter: (value) => formatEuros(value),
      },
      {
        field: 'sumprice',
        headerName: 'Summa',
        width: 100,
        // valueGetter: (params) => (params.row.quantity * params.row.price)  / 100,
        valueFormatter: (value) => formatEuros(value),
      },
      { field: 'paymentstate', headerName: 'Maksu', width: 300 },
      {
        field: 'pdfurl',
        headerName: 'Lippu (PDF)',
        width: 130,
        sortable: false,
        renderCell: (params) =>
          params.value ? (
            <a href={params.value} target='_blank' rel='noopener noreferrer'>
              <PictureAsPdfIcon fontSize='small' /> Lataa
            </a>
          ) : (
            ''
          ),
      },
      { 
        field: 'remove',
        headerName: 'Poista',
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          if (params.row.canRemove) {
            return (
              <Button
                color='danger'
                size='sm'
                disabled={this.state.deleting}
                onClick={() => this.askRemove(params.row)}
              >
                Poista
              </Button>
            )
          } else {
            return ''
          }
        }
      }
    ]
    return columns
  }

  // Reads the props, never state.eventtickets: state holds the already flattened rows, so
  // re-running over state expanded every row by its purchases a second time.
  filterData = () => {
    const data = this.props.eventtickets || []
    const d = data.flatMap((item, index) => {
      const payments = Array.isArray(item.payments) ? item.payments : []
      const usedPayments = new Set()
      // Cancelled purchases are kept on the document for the money history but must not
      // show here - dropping out of this list is what 'remove' looks like to the manager.
      return activePurchases(item).map((purchase, purchaseIndex) => {
        const _item = { ...item }
        // A purchase can point at a variation that has since been removed from the event.
        const variantion = (_item.variations || []).find((v) => v.id === purchase.variationId)

        const quantity = purchase.quantity || 1
        // Euros. purchase.price is the per-ticket price; fall back to the variation and
        // then to the event itself, since older purchases do not all carry one.
        const price = purchase.price ?? variantion?.price ?? _item.price ?? 0

        _item.paymentstate = paymentsText(matchPayments(purchase, payments, usedPayments))
        // Removal is not restricted by payment state. The original intent here was to allow
        // it only when unpaid, but manual additions default to 'Lisää myös maksu' checked,
        // so that rule would block exactly the case removal exists for. What it does need is
        // a paymenttoken: cancelling addresses a whole order by its token, and some legacy
        // purchases carry none, so those cannot be addressed at all.
        _item.canRemove = !!purchase.paymenttoken
        // _item.id below becomes the composite row key and purchase.id is the event id, so
        // the event has to be carried separately for the cancel call to address it.
        _item.eventticketid = item.id
        // Cancelling takes the whole order with it, so the dialog has to say how much that
        // is: lines in the order, and tickets once quantities are counted.
        _item.orderlines = orderPurchases(item, purchase.paymenttoken).length
        _item.ordertickets = orderTicketCount(item, purchase.paymenttoken)
        // The generated pdf ticket is keyed by paymenttoken, i.e. one file per order, so a
        // multi row order repeats the same link. Plain string on the row so the CSV export
        // gets the url rather than markup.
        const pdf = (item.pdfs || []).find((x) => x.id === purchase.paymenttoken)
        _item.pdfurl = (pdf && pdf.pdfurl) || ''
        _item.variantname = variantion ? variantion.name : ''
        _item.productCode = variantion ? variantion.productCode || '' : ''
        _item.quantity = quantity
        _item.price = price
        _item.sumprice = price * quantity
        // purchase.id repeats the event ticket id and gives no row identity, so the row
        // key is built from the position of the purchase within its event ticket.
        _item.id = item.id + '-' + purchase.variationId + '-' + index + '-' + purchaseIndex
        return {
          ...purchase,
          ..._item,
        }
      })
    })

    //   .sort((a, b) => {
    //   // sort by created seconds
    //   return b.created._seconds - a.created._seconds
    // })
    this.setState({ eventtickets: d })
  }

  componentDidUpdate(prevProps) {
    if (this.props.eventtickets !== prevProps.eventtickets) {
      this.filterData()
    }
  }

  componentDidMount() {
    this.filterData()
  }

  toggleAddCard = () => {
    this.setState({
      showAddCardRow: !this.state.showAddCardRow,
    })
  }

  // handleSaved = () => {
  //   this.toggleAddCard()
  //   this.props.onSaved()
  // }

  // onSaveBenefitCard = async (cardid, note) => {
  //   this.setState({ saving: true })
  //   const userid = this.props.personId
  //   await this.props.firebase.addNewPersonBenefitCard(userid, cardid, note)
  //   this.setState(
  //     {
  //       saving: false,
  //     },
  //     this.handleSaved
  //   )
  // }

  // handlePlus = async (id) => {
  //   this.setState({ loadingPlusMinus: { ...this.state.loadingPlusMinus, [id]: true } })
  //   let remaining = this.state.orders.find((card) => card.id === id).remaining
  //   if (!remaining) {
  //     remaining = 1
  //   } else {
  //     remaining++
  //   }
  //   await this.props.firebase.updatePersonBenefitCard(this.props.personId, id, remaining)
  //   this.setState({ loadingPlusMinus: { ...this.state.loadingPlusMinus, [id]: false } }, this.props.onSaved)
  // }

  // handleMinus = async (id) => {
  //   this.setState({ loadingPlusMinus: { ...this.state.loadingPlusMinus, [id]: true } })
  //   let remaining = this.state.orders.find((card) => card.id === id).remaining
  //   if (!remaining) {
  //     remaining = 0
  //   } else {
  //     remaining--
  //   }

  //   await this.props.firebase.updatePersonBenefitCard(this.props.personId, id, remaining)
  //   this.setState({ loadingPlusMinus: { ...this.state.loadingPlusMinus, [id]: false } }, this.props.onSaved)
  // }


  render() {
    // if (this.state.showAddCardRow) {
    //   return (
    //     <AddEventTicketRow
    //       onSubmit={this.onSaveBenefitCard}
    //       benefitcards={this.state.benefitcards ? this.state.benefitcards.filter((card) => card.collection === 'activities') : []}
    //       onCancel={this.toggleAddCard}
    //       saving={this.state.saving}
    //     />
    //   )
    // } else {

      return (
        <div className='animated fadeIn'>
          <Row style={{ marginTop: 5, marginBottom: 10 }}>
            <Col style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
              <div style={{ cursor: 'pointer' }} onClick={this.toggleAddCard}>
                <AddCircleIcon fontSize='small' /> Lisää tapahtumalippu
              </div>
              {/* Saving refreshes on its own, but the backend writes the purchase a second
                  or two after the call returns, so a manual retry has to stay available. */}
              {this.props.onRefresh && (
                <div
                  style={{ cursor: this.props.refreshing ? 'default' : 'pointer' }}
                  onClick={this.props.refreshing ? undefined : this.props.onRefresh}
                >
                  {this.props.refreshing ? <Spinner size={'sm'} /> : <RefreshIcon fontSize='small' />} Päivitä
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ display: 'flex', minHeight: 'calc(100vh - 400px)', backgroundColor: '#FFFFFF' }}>
                <div style={{ flexGrow: 1 }}>
                  <DataGrid
                    rows={this.state.eventtickets}
                    columns={this.getColumns()}
                    density='compact'
                    pageSize={20}
                    disableSelectionOnClick={true}
                    rowsPerPageOptions={[20, 50, 100]}
                    pagination
                    initialState={{ sorting: { sortModel: [{ field: 'start', sort: 'desc' }] } }}
                    components={{
                      NoRowsOverlay: () => (
                        <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', height: '100%' }}>
                          Ei löytynyt tapahtumalippuja henkilölle
                        </div>
                      ),
                      // NoResultsOverlay: () => (
                      //   <div height="100%" alignItems="center" justifyContent="center">
                      //     Local filter returns no result
                      //   </div>
                      // )
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <pre>
                {JSON.stringify(this.state.orders, null, 2)}
              </pre>
            </Col>
          </Row> */}
          <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={!!this.state.confirmRemove}
            onClose={this.closeRemove}
            aria-labelledby='remove-eventticket-title'
            style={{ zIndex: '1000' }}
          >
            <DialogTitle id='remove-eventticket-title'>Vahvista poisto</DialogTitle>
            <DialogContent>
              {this.state.confirmRemove && (
                <>
                  Poistetaanko lippu <b>{this.state.confirmRemove.name}</b>
                  {this.state.confirmRemove.variantname ? <> - <b>{this.state.confirmRemove.variantname}</b></> : ''}
                  {' '}({formatEuros(this.state.confirmRemove.sumprice)}) henkilöltä?
                  {/* The pdf ticket covers the whole order, so a single line cannot be
                      cancelled on its own without leaving the customer a pdf that still
                      lists it. Say so before the manager finds out afterwards. */}
                  {this.state.confirmRemove.orderlines > 1 && (
                    <Alert severity='warning' style={{ marginTop: 8 }}>
                      Tilauksessa on {this.state.confirmRemove.orderlines} lippuriviä
                      (yhteensä {this.state.confirmRemove.ordertickets} lippua) ja <b>koko tilaus
                      perutaan</b>. Tilauksen pdf-lippu sisältää kaikki rivit, joten yksittäistä
                      riviä ei voi perua erikseen.
                    </Alert>
                  )}
                  <div style={{ marginTop: 8 }}>
                    {this.state.confirmRemove.orderlines > 1 ? 'Liput merkitään perutuiksi eivätkä ne näy enää listoilla.' : 'Lippu merkitään perutuksi eikä se näy enää listoilla.'}
                    {' '}<b>Maksu jää kirjatuksi tapahtumalle</b> – rahoja ei palauteta tällä
                    toiminnolla.
                  </div>
                </>
              )}
              {this.state.removeError && (
                <Alert severity='error' style={{ marginTop: 8 }}>
                  Lipun poisto epäonnistui: {this.state.removeError}
                </Alert>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.removePersonEventTicket} color='danger' disabled={this.state.deleting}>
                {this.state.confirmRemove && this.state.confirmRemove.orderlines > 1 ? 'Poista koko tilaus' : 'Poista lippu'}
                {this.state.deleting ? <CircularProgress size={12} /> : ''}
              </Button>
              <Button onClick={this.closeRemove} color='primary' disabled={this.state.deleting}>
                Peruuta
              </Button>
            </DialogActions>
          </Dialog>
          <EventTicketDialog
             title={'Lisää lippuja henkilölle'}
            open={this.state.showAddCardRow}
            onClose={this.toggleAddCard}
            onUpdate={this.props.onUpdate}
            payer={this.props.person}
          />
        </div>
      )
    }
  // }
}
export default withFirebase(PersonEventTickets)
